import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#b3703d',
        secondary: '#579DD2',
        anchor: '#000',
        accent: '#ff8a65',
        success: '#27C19E',
      },
      dark: {
        primary: '#b3703d',
        secondary: '#579DD2',
        anchor: '#fff',
        success: '#27C19E',
      },
    },
  },
});
